/**
 * imageRequestData is used to define the image request data for different screen sizes.
 * for now we have 3 screen sizes: mobile, tablet and desktop. But we only utilize mobile and desktop.
 * This config can be used once we are ready to support multi config request for different screen sizes.
 * s: mobile, m: tablet, l: desktop
 */
export const imageRequestData = {
    s: {
        count: 8,
        width: 400,
        height: 400,
    },
    m: {
        count: 8,
        width: 730,
        height: 360,
    },
    l: {
        count: 8,
        width: 800,
        height: 800,
    },
    l_v2: {
        // Rename to "l" after integration ACT-5038
        count: 8,
        width: 1280,
        height: 720,
    },
};

export enum imageRequestDataType {
    MOBILE = 's',
    TABLET = 'm',
    DESKTOP = 'l',
    DESKTOP_V2 = 'l_v2', // Rename to "DESKTOP" after integration ACT-5038
}
